
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import { warkLabel } from '@/models/wark';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';
import moment from 'moment';
import { getCurrentMonth } from '@/common/utils';
import { ParticipateInActivitiesModel } from '@/models/wark.model';
import LookShopDrawer from '@/views/workbenches/subassembly/LookShopDrawer.vue';
import { AuthEnum } from '@/services/permission.service';

@Component({
  components: {
    LookShopDrawer,
  },
})
export default class ParticipateInActivities extends Vue {
  columns = [
    ...warkLabel.init('PerformanceTargetConfiguration').TeamMemberSuperior,
    ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
    ...warkLabel.init('PerformanceTargetConfiguration').action,
  ];

  AuthEnum = AuthEnum;

  @Ref()
  lookShopDrawer!: LookShopDrawer;

  moment = moment;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  filterForm: any = {
    month: '',
    dept_id: undefined,
    group_id: undefined,
    agent_name: '',
  };

  dept_list: any = [];

  group_list: any = [];

  data = [];

  typeChild: string | null = localStorage.getItem('typeChild');

  selectedValue: any = '1';

  module: any = '';

  @Watch('$route.query')
  onRouteChange() {
    const { page, pageSize, module, month, dept_id, group_id, agent_name } = this.$route.query;
    const queryParams: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      module,
    };
    this.module = module || '';
    if (month) {
      queryParams.month = month;
      this.filterForm.month = month;
    } else {
      queryParams.month = getCurrentMonth();
      this.filterForm.month = getCurrentMonth();
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
      this.filterForm.dept_id = +dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
      this.filterForm.group_id = +group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
      this.filterForm.agent_name = agent_name;
    }
    // this.getQueryParams();
    this.getList(queryParams);
  }

  async getList(queryParams: any) {
    const res = await this.workbenchesService.getQuickEntrance(queryParams, this.$el);
    this.data = ParticipateInActivitiesModel.from(res);
  }

  async exportData() {
    const queryParams: any = {
      module: this.module,
      export: 1,
    };
    const { month, dept_id, group_id, agent_name } = this.filterForm;
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    await this.workbenchesService.getQuickEntranceExport(queryParams, '洗车节活动数据');
  }

  reset() {
    this.filterForm = {
      month: '',
      dept_id: '',
      group_id: '',
      agent_name: '',
    };
    this.getQueryParams();
  }

  refresh() {
    // console.log('refresh');
  }

  handleClick(record: any) {
    if (record.spu_id) {
      this.lookShopDrawer.init(record, this.filterForm.month);
    } else {
      this.$message.warning('该同学下没有参加活动的门店');
    }
  }

  handleChange(value: any) {
    this.changeColumns(value);
  }
  changeColumns(val: string) {
    switch (val) {
      case 'director': // 总监
        this.columns = [
          ...warkLabel.init('PerformanceTargetConfiguration').departmentC,
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalGroup,
          ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
          ...warkLabel.init('PerformanceTargetConfiguration').action,
        ];
        break;
      case 'assistantDirector': // 助理
        this.columns = [
          ...warkLabel.init('PerformanceTargetConfiguration').departmentC,
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalGroup,
          ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
          ...warkLabel.init('PerformanceTargetConfiguration').action,
        ];
        break;
      case 'kaTeamLeader': // 部长
        this.columns = [
          ...warkLabel.init('PerformanceTargetConfiguration').departmentC,
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalGroup,
          ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
          ...warkLabel.init('PerformanceTargetConfiguration').action,
        ];
        break;
      case 'ordinaryTeamMinister': // 部长
        this.columns = [
          ...warkLabel.init('PerformanceTargetConfiguration').departmentC,
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalGroup,
          ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
          ...warkLabel.init('PerformanceTargetConfiguration').action,
        ];
        break;
      case 'kaTeamMinister': // 组长
        this.columns = [
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalChild,
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalGroup,
          ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
          ...warkLabel.init('PerformanceTargetConfiguration').action,
        ];
        break;
      case 'ordinaryTeamLeader': // 组长
        this.columns = [
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalChild,
          ...warkLabel.init('PerformanceTargetConfiguration').graphicalGroup,
          ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
          ...warkLabel.init('PerformanceTargetConfiguration').action,
        ];
        break;
      default: // 普通
        this.columns = [
          ...warkLabel.init('PerformanceTargetConfiguration').TeamMemberSuperior,
          ...warkLabel.init('PerformanceTargetConfiguration').grinfo,
          ...warkLabel.init('PerformanceTargetConfiguration').action,
        ];
        break;
    }
    const obj: any = {
      dept_name: 'dept_id',
      dept_manager: 'dept_id',
      dept_activity_target_num: 'dept_id',
      dept_activity_num: 'dept_id',
      dept_activity_ratio: 'dept_id',
      group_manager: 'group_id',
      group_activity_target_num: 'group_id',
      group_activity_num: 'group_id',
      group_activity_ratio: 'group_id',
      group_name: 'group_id',
    };
    this.columns.forEach((res: any) => {
      if (Object.prototype.hasOwnProperty.call(obj, res.dataIndex)) {
        res.customRender = (text: any, row: any, index: any) => {
          return this.customRender(text, row, index, obj[res.dataIndex]);
        };
      }
    });
  }
  customRender(text: any, row: any, index: any, column: any) {
    const prevRow: any = this.data[index - 1];
    if (prevRow && prevRow[column] === row[column]) {
      return {
        children: text,
        attrs: {
          rowSpan: 0,
        },
      };
    }
    let rowSpan = 1;
    const _i: number = index;
    for (let i = _i + 1; i < this.data.length; i++) {
      const currentRow: any = this.data[i];
      if (currentRow[column] === row[column]) {
        rowSpan++;
      } else {
        break;
      }
    }
    return {
      children: text,
      attrs: {
        rowSpan,
      },
    };
  }

  changeMonth(val: any) {
    const year = val._d.getFullYear(); // 获取当前年份，例如：2021
    let month: any = Number(val._d.getMonth()) + 1; // 获取当前月份，注意需要加1，例如：9
    if (month < 10) {
      month = `0${month}`;
    }
    const _d = `${year}-${month}`;
    this.filterForm.month = _d;
  }

  async getDeptInfo() {
    const res = await this.workbenchesService.getDeptInfo();
    this.dept_list = res;
    const { dept_id } = this.$route.query;
    if (!dept_id) return;
    const deptId = Number(dept_id);
    this.group_list = this.dept_list.find((item: any) => item.dept.id === deptId).group;
  }

  selectOption(val: any) {
    this.group_list = this.dept_list.find((res: any) => res.dept.id === val).group;
    this.filterForm.group_id = undefined;
  }

  search() {
    this.getQueryParams();
  }

  getQueryParams() {
    const { month, dept_id, group_id, agent_name } = this.filterForm;
    const queryParams: any = {
      module: this.module,
    };
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    queryParams.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query: queryParams,
    });
  }


  mounted() {
    // const columns = warkLabel.init('PerformanceTargetConfiguration');
    this.changeColumns(this.typeChild!);
    this.getDeptInfo();
    this.onRouteChange();
  }

  back() {
    this.$router.push({ name: 'workbenches.index' });
  }
}
